import { HttpClient, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { Observable, of } from 'rxjs';
import { FIREBASE_URL_FUNCTIONS } from 'src/app/app.constants';
import { FunctionOptions } from '../domain/function-options';
import { catchError } from 'rxjs/operators';
import { FireLoggingService } from './fire-logging.service';

@Injectable({
    providedIn: 'root'
})
export abstract class BaseService {

    protected constructor(
        protected firestore: AngularFirestore,
        protected http: HttpClient,
        protected functions: AngularFireFunctions,
        protected fireLogging: FireLoggingService
    ) { }

    /**
     * Call a function using according the function options.
     * @param entity to be sent to the function
     * @param functionName name of the function to be called
     * @param functionOpts options to configure the request
     */
    protected callFunction(entity: any, functionName: string, functionOpts: FunctionOptions): Observable<any> {
        let request: any;
        if (functionOpts.type === 'callable') {
            request = this.functions.httpsCallable(functionName)(entity);
        } else {
            let httpRequest;
            if (functionOpts.httpMethod === 'GET' || functionOpts.httpMethod === 'DELETE') {
                httpRequest = new HttpRequest(functionOpts.httpMethod, FIREBASE_URL_FUNCTIONS);
            } else {
                httpRequest = new HttpRequest(functionOpts.httpMethod, FIREBASE_URL_FUNCTIONS, entity);
            }
            request = this.http.request(httpRequest);
        }
        return request.pipe(
            catchError((error) => {
                const message = error.error ? error.error.message : error.message;
                this.fireLogging.sendErrorLog(`An error occurred calling the function 
                    ${ functionName }, details: ${ message || JSON.stringify(error) }`);
                return of({error});
            })
        );
    }
}
